"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteEcheck = exports.saveECheck = exports.getEChecks = void 0;
var axios_1 = __importDefault(require("axios"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var Forte = __importStar(require("../../payments-processors/forte/forte"));
var storage_1 = require("../../utils/storage");
/**
 * GET ALL CUSTOMER E-CHECKS
 * @param token
**/
function getEChecks(config) {
    var appEnvironment = config && config.environment != null ? config.environment : storage_1.getStorage('ENVIRONMENT');
    var customerToken = config && config.token ? config.token : storage_1.getStorage('TOKEN');
    var FORTE_E_CHECKS = "https://echecks" + appEnvironment + ".cargosprintgroup.com";
    return rxjs_1.from(axios_1.default({
        method: 'GET',
        url: FORTE_E_CHECKS + "/customerECheques",
        headers: { Authorization: "Bearer " + customerToken }
    })).pipe(operators_1.map(function (_a) {
        var data = _a.data;
        return data;
    }));
}
exports.getEChecks = getEChecks;
/**
 * GLOBAL FUNCTION TO SAVE E-CHECKS
 * @param echeck
 * @param config
**/
function saveECheck(echeck, config) {
    return Forte.saveECheck(echeck, config);
}
exports.saveECheck = saveECheck;
/**
 * GLOBAL FUNCTIONS TO DELETE E-CHECKS
 * @param echeck
 * @param config
**/
function deleteEcheck(echeck, config) {
    return Forte.deleteEcheck(echeck, config);
}
exports.deleteEcheck = deleteEcheck;
//# sourceMappingURL=e-check.js.map